export default __webpack_public_path__ + "static/media/67.c60e77cc.png";